export default function pushDataLayer(
  data: Record<string, any> // eslint-disable-line @typescript-eslint/no-explicit-any
) {
  window.dataLayer?.push(data);
}
